import { Component, ViewChild, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BuyerRepresentation } from '../../models/buyerRepresentation';

@Component({ standalone: false,
    selector: 'app-representations-table',
    templateUrl: './representations-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./representations-table.component.scss']
  })
  export class RepresentationsTableComponent {
    @ViewChild(MatSort) set matSort(ms: MatSort) {
      if(ms){
        this.sort = ms;
        this.sort.disableClear=true;
        this.setDataSourceAttributes();
      }
    }
    private setDataSourceAttributes() {
      if(this.dataSource){
        this.dataSource.sort = this.sort;
      }
    }

    readonly buyerRepresentations = input<BuyerRepresentation[]|undefined>(undefined);
  
    @ViewChild(MatPaginator, {static: true}) paginator?: MatPaginator;

    public sort?: MatSort;
    public dataSource: MatTableDataSource<BuyerRepresentation> = new MatTableDataSource(new Array<BuyerRepresentation>());

    constructor(){
      effect(() => {
        this.processBuyerRepresentations();
      });
    }

    get displayedColumns(){
      return ['buyerFullName', 'header', 'displayConfirmed', 'displayStatus'];
    }

    private processBuyerRepresentations(){
      if(this.buyerRepresentations()){
        this.dataSource.data=this.buyerRepresentations()!;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }
  }